import useRequest from '@hooks/useRequest';
import { IContratoOperadora } from '@model/ContratoOperadora';
import React from 'react';

export function useContratoOperadoraService () {
    const _request = useRequest();

    const listarAtivos = React.useCallback(() => {
        return _request.get<IContratoOperadora[]>(`ContratoOperadora/ListarAtivos`);
    }, [_request]);
    
    return React.useMemo(() => ({
        listarAtivos
    }), [listarAtivos]);
}